import { render, staticRenderFns } from "./RoleUserList.vue?vue&type=template&id=22d2be78"
import script from "./RoleUserList.vue?vue&type=script&lang=js"
export * from "./RoleUserList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22d2be78')) {
      api.createRecord('22d2be78', component.options)
    } else {
      api.reload('22d2be78', component.options)
    }
    module.hot.accept("./RoleUserList.vue?vue&type=template&id=22d2be78", function () {
      api.rerender('22d2be78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/sys/role/RoleUserList.vue"
export default component.exports